module.exports = __webpack_public_path__ + "static-v-shop/1792141392954/img/hotsale-desktop.42d5a010.jpg";